var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { TermsConditionWrapper } from './subcomponents';
import TermsConditionsHeader from '../TermsConditionsHeader';
import TermsConditionsBody from '../TermsConditionsBody';
import TermsConditionsFooter from '../TermsConditionsFooter';
import AriaLiveRegion from '../../templates/AriaLiveRegion';
var TermsCondition = function (_a) {
    var currentAlertData = _a.currentAlertData, alertFormData = _a.alertFormData, onCancel = _a.onCancel, hasConsentBanner = _a.hasConsentBanner, onConsentSave = _a.onConsentSave, onConsentCancel = _a.onConsentCancel, isProfileDataVisible = _a.isProfileDataVisible;
    var t = useTranslation().t;
    var ADA_TEXT_TERMS_CONDITIONS_I18N = t('adaHelperText.termsConditions');
    return (_jsxs(_Fragment, { children: [_jsx(AriaLiveRegion, { children: ADA_TEXT_TERMS_CONDITIONS_I18N }), _jsxs(TermsConditionWrapper, __assign({ "data-test": "TermsConditionWrapper" }, { children: [_jsx(TermsConditionsHeader, { currentAlertData: currentAlertData, alertFormData: alertFormData, hasConsentBanner: hasConsentBanner, isProfileDataVisible: isProfileDataVisible }), _jsx(TermsConditionsBody, {}), _jsx(TermsConditionsFooter, { currentAlertData: currentAlertData, alertFormData: alertFormData, onCancel: onCancel, onConsentSave: onConsentSave, onConsentCancel: onConsentCancel, hasConsentBanner: hasConsentBanner })] }))] }));
};
export default TermsCondition;
